const getters = {
  loginName: state => state.user.loginName,
  permCodes: state => state.user.permCodes,
  headimgurl: state => state.user.headimgurl,
  tenantName: state => state.user.tenantName,
  tenants: state => state.user.tenants,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews
};
export default getters;
